import { prepareSite } from '../site-switch/bootstrap';

const legacyBasePath = '/aivideo';
if (
  window.location.pathname === legacyBasePath ||
  window.location.pathname.startsWith(`${legacyBasePath}/`)
) {
  const normalizedPath = window.location.pathname.slice(legacyBasePath.length) || '/';
  window.history.replaceState(
    window.history.state,
    '',
    `${normalizedPath}${window.location.search}${window.location.hash}`,
  );
}

void prepareSite('desktop')
  .then((shouldStart) => {
    if (shouldStart) {
      return import('./desktop-main');
    }
    return undefined;
  })
  .catch(() => import('./desktop-main'));
